import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Image from "../../image/Image";
import Button from "../../customMui/Button";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import { websiteBaseUrl } from "../../../util/urlConfig";
import "./topbar.css";

const Topbar = ({
    menuContent = [],
    logoSize = "medium",
    topbarMiddleContent = null,
    showBrand = true,
    colorMode = "light",
    onColorModeToggle = null
}) => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [mobileMenuClass, setMobileMenuClass] = useState(null);
    const location = useLocation();

    useEffect(() => {
        if (isMobileMenuOpen) {
            setMobileMenuClass("topbar-menu-mobile-open");
            return;
        }
        // close class is only applied when closing, not at initial page load
        if (mobileMenuClass) {
            setMobileMenuClass("topbar-menu-mobile-close");
        }
    }, [isMobileMenuOpen])

  return (
    <div className="topbar-container">

      <div className="topbar">

        {showBrand ? (
          <div className="topbar-left-content">
            <div className="topbar-left-content-top">
              <a
                href={websiteBaseUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{ cursor: "pointer" }}
              >
                <Image
                  className={`topbar-logo topbar-logo-${logoSize}`}
                  src="/logo/wnp-logo-black.svg"
                  alt="WannaPractice"
                />
              </a>
              <div className="topbar-middle-content">{topbarMiddleContent}</div>
            </div>
            <div className="topbar-partnership-logo-container">
              <span>Powered by</span>
              <div>
                <Image
                  className={`topbar-partner-logo topbar-partner-logo-${logoSize}`}
                  src="/logo/ivox-favicon.webp"
                  alt="iVox logo"
                />
                <span>iVox</span>
              </div>
              <span style={{ marginLeft: '4px' }}>Learning</span>
            </div>
          </div>
        ) : null}
        {onColorModeToggle ? (
          <div className="topbar-mobile-actions">
            <button
              type="button"
              className={`topbar-theme-toggle topbar-theme-toggle-${colorMode}`}
              onClick={onColorModeToggle}
              aria-label={colorMode === "dark" ? "Switch to light mode" : "Switch to dark mode"}
              title={colorMode === "dark" ? "Light mode" : "Dark mode"}
            >
              <span>{colorMode === "dark" ? <DarkModeIcon /> : <LightModeIcon />}</span>
            </button>
            {menuContent.map((menuItem, index) => {
              if (menuItem?.isHidden || menuItem.type !== "button") return null;
              return (
                <div key={index} className="topbar-mobile-action-button">
                  <Button
                    variant="outlined"
                    customProps={{ onClick: menuItem.button.onClick, sx: { fontSize: "14px" } }}
                  >
                    {menuItem.button.name}
                  </Button>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="topbar-menu-mobile-container">
            <button
              className="topbar-menu-toggle-button"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              {isMobileMenuOpen === false ? (
                <Image src="/icon/hamburger.svg" alt="Menu" />
              ) : (
                <Image src="/icon/close.svg" alt="Close Menu" />
              )}
            </button>
          </div>
        )}
        <div className="topbar-menu-desktop-container">
          {onColorModeToggle ? (
            <button
              type="button"
              className={`topbar-theme-toggle topbar-theme-toggle-${colorMode}`}
              onClick={onColorModeToggle}
              aria-label={colorMode === "dark" ? "Switch to light mode" : "Switch to dark mode"}
              title={colorMode === "dark" ? "Light mode" : "Dark mode"}
            >
              <span>{colorMode === "dark" ? <DarkModeIcon /> : <LightModeIcon />}</span>
            </button>
          ) : null}
          {menuContent.map((menuItem, index) => {
            if (menuItem?.isHidden) return null;
            if (menuItem.type === 'link') {
              let linkClassName = 'topbar-menu-desktop-link';
              if (location.pathname === menuItem.link.path) {
                linkClassName = 'topbar-menu-desktop-link topbar-menu-desktop-link-selected';
              }
              return (
                <div key={index} className={linkClassName}>
                  <Link to={menuItem.link.path}>{menuItem.link.name}</Link>
                </div>
              );
            }
            if (menuItem.type === 'button') {
              return (
                <div key={index} className="topbar-menu-desktop-button">
                  <Button
                    variant="outlined"
                    customProps={{ onClick: menuItem.button.onClick, sx: { fontSize: '18px' } }}
                  >
                    {menuItem.button.name}
                  </Button>
                </div>
              );
            }
            if (menuItem.type === 'text') {
              return (
                <div key={index} className="topbar-menu-desktop-link">
                  <a>{typeof menuItem.text === 'string' ? menuItem.text : JSON.stringify(menuItem.text)}</a>
                </div>
              );
            }
            return null;
          })}
        </div>
      </div>
      {!onColorModeToggle ? (
        <div
          className="topbar-menu-mobile-container"
          onClick={(e) => {
            if (!e.target.classList.value.includes('topbar-menu-mobile-inner')) {
              setIsMobileMenuOpen(false);
            }
          }}
        >
          <div className={`topbar-menu-mobile ${mobileMenuClass ? mobileMenuClass : 'hidden'}`}>
            <div className="topbar-menu-mobile-inner">
              {menuContent.map((menuItem, index) => {
                if (menuItem?.isHidden) return null;
                if (menuItem.type === 'link') {
                  let linkClassName = 'topbar-menu-mobile-inner-link';
                  if (location.pathname === menuItem.link.path) {
                    linkClassName = 'topbar-menu-mobile-inner-link topbar-menu-mobile-inner-link-selected';
                  }
                  return (
                    <div key={index} className={linkClassName}>
                      <Link to={menuItem.link.path}>{menuItem.link.name}</Link>
                    </div>
                  );
                }
                if (menuItem.type === 'button') {
                  return (
                    <div key={index} className="topbar-menu-mobile-inner-button">
                      <Button
                        variant="outlined"
                        customProps={{ onClick: menuItem.button.onClick, sx: { fontSize: '18px', width: '100%' } }}
                      >
                        {menuItem.button.name}
                      </Button>
                    </div>
                  );
                }
                if (menuItem.type === 'text') {
                  return (
                    <div key={index} className="topbar-menu-mobile-inner-link">
                      <a>{typeof menuItem.text === 'string' ? menuItem.text : JSON.stringify(menuItem.text)}</a>
                    </div>
                  );
                }
                return null;
              })}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default Topbar;
